// extracted by mini-css-extract-plugin
module.exports = {"container":"_1kxeBS3U62DPWO7iX9dzBP","heading":"_1fLbEjqxje37Ae7UIrkfiE","headingText":"ZqOI6ngIfz-IqVRJrjb2-"};